
export const fallbackDate = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  0
);